<template>
    <div>
        <my-header
            title="积分兑换"
            isBack
        />
        
        <div class="info-body">
            <van-icon class="succeed-icon" name="checked" />
            <div class="info-content">兑换成功</div>
        </div>

        <van-row>
            <van-col 
                class="btn-body" 
                v-for="item in btnList"
                :key="item.id"
                :span="24 / btnList.length"
            >
                <van-button class="btn" @click="go2(item.path)">{{item.title}}</van-button>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import MyHeader from '@/components/myHeader'
import { useRoute } from 'vue-router'

export default {
    name: 'PointSucceed',
    components: {
        MyHeader
    },
    setup() {
        const id = useRoute().query.id
        const btnList = [
            {id: 0, title: '查看详情', path: '/my/point/store/succeed/detail'}
        ]

        return {
            id,
            btnList
        }
    },
    methods: {
        go2(path) {
            this.$router.replace({
                path: path,
                query: {
                    id: this.id
                }
            })
        }
    }
}
</script>

<style scoped>
.info-body {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 90px;
}

.info-img {
    width: 90px;
    margin-bottom: 30px;
}

.info-content {
    font-size: 18px;
    font-weight: 600;
    color: #3D98F6;
}

.succeed-icon {
    font-size: 80px;
    color: #3D98F6;
    margin-bottom: 20px;
}

.btn-body {
    text-align: center;
}

.btn {
    background: linear-gradient(0deg, #3BA0E8 0%, #52F0F2 100%);
    color: #FFF;
    border: none;
    height: 50px;
    width: 30vw;
    border-radius: 50px;
}
</style>